import './css/style.scss'
import enterPage from './js/enterPage.js';
import Loader from './js/loader.js';
import nav from './js/nav.js';
import scroll from './js/scroll.js';
import textModal from './js/textModal.js';
import audioPlayer from './js/audioPlayer.js';
import pageZoom from './js/pageZoom.js';
import rotateMessage from './js/rotateMessage.js';

Loader.init({ timeout: 2500 });
enterPage.init();
window.scroll = scroll;
scroll.init();
nav.init();
window.nav = nav; // expose for pageZoom synchronization
textModal.init();
audioPlayer.init();
pageZoom.init();
window.pageZoom = pageZoom; // expose zoom state for nav progress syncing
rotateMessage.init();
// pagesAuto removed: pages now statically generated into index.html by gen:pages script.

// Lenis removed; custom momentum logic now powers both desktop (horizontal) and mobile (vertical) scrolling.
